var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"odd_type_description padding_left_25 text_right"},[_vm._v(" "+_vm._s(_vm.description)+" "),(_vm.specialValue)?_c('span',[_vm._v("| "+_vm._s(_vm.specialValue))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }